import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

function readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|;\\s*)" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[1]) : null;
}

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (!["get", "head", "options"].includes(method)) {
    const csrf = readCookie("pk_csrf");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401) {
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(e);
  }
);

export function formatError(err) {
  if (err == null) return "Something went wrong";
  // Unwrap Axios error → use response detail when available.
  if (err && typeof err === "object" && err.isAxiosError) {
    const detail = err.response?.data?.detail;
    if (detail) return formatError(detail);
    if (err.response?.status === 403) return "You don't have permission for this action.";
    if (err.response?.status === 404) return "Not found.";
    if (err.response?.status === 401) return "Please log in again.";
    return err.message || "Request failed";
  }
  if (typeof err === "string") return err;
  if (Array.isArray(err))
    return err.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join("; ");
  if (err?.msg) return err.msg;
  return String(err);
}

export default api;
